import React, { useState } from 'react';

import { DemoBookingDialog } from './DemoBookingDialog';

export function DemoBookingButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="tour-guide-launcher tour-guide-launcher--demo"
        data-testid="demo-booking-button"
        aria-label="Book a live demo with the WeNext team"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <svg
          className="tour-guide-launcher__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        <span className="tour-guide-launcher__label">Demo</span>
      </button>

      {open && <DemoBookingDialog onClose={() => setOpen(false)} />}
    </>
  );
}
